module.exports = __webpack_public_path__ + "img/icon-next.d7a58a3b.svg";